import { render } from "./EnrolleeDetailInsightComponent.vue?vue&type=template&id=e8e950a2&scoped=true"
import script from "./EnrolleeDetailInsightComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeDetailInsightComponent.vue?vue&type=script&lang=js"

import "./EnrolleeDetailInsightComponent.vue?vue&type=style&index=0&id=e8e950a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e950a2"]])

export default __exports__